import type { Seo } from './schemas';
import { HOME_URL } from '~/constants/config';

export const defaultCoverUrl =
  'https://lifehacker.ru/wp-content/plugins/lh-og-generator/src/PublicArea/static/img/default_cover.jpg';

export function createNotFoundSeo(path: string): Seo {
  return createErrorSeo({
    path,
    title: 'Страница не найдена — Лайфхакер',
    description: 'Страница не найдена или была удалена.',
  });
}

export function createUnavailableSeo(path: string): Seo {
  return createErrorSeo({
    path,
    title: 'Что-то пошло не так — Лайфхакер',
    description: 'Временно не удалось загрузить страницу.',
  });
}

function createErrorSeo({
  path,
  title,
  description,
}: {
  path: string;
  title: string;
  description: string;
}): Seo {
  return {
    title,
    description,
    canonical: `${HOME_URL}${path}`,
    robots: 'noindex,nofollow',
    og_image: defaultCoverUrl,
    schema: '',
    schema_recipe: '',
    schema_howto: '',
    schema_faq: '',
  };
}
